export enum ResignationStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL_OF_MANAGER,
  AWAITING_APPROVAL_OF_HOD,
  AWAITING_APPROVAL_OF_HR_ADMIN,
  AWAITING_APPROVAL_OF_HR_ADMIN_DIRECTOR,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  APPROVED,
  CANCELLED,
  AWAITING_APPROVAL_OF_PERSONAL_OFFICER_ASSISTANT,
  REJECTED,
  AWAITING_APPROVAL_OF_OPERATION_MANAGER,
}
